import React from "react"
import { routeScreenMapping, FIREBASE_STATE_KEYS } from "./helpers"
import { FirebaseService } from "./FirebaseService"
import { connect } from "react-redux"
import _ from "../utils/lodashUtils"

const mapStateToProps = (state) => ({
  userDetails: _.get(state, "auth.user", {}),
})

// handles navigation logic based on firebase state changes.
export const NavigationController = connect(
  mapStateToProps,
  null
)((props) => {
  const {
    location: { pathname },
    userDetails,
  } = props
  React.useEffect(() => {
    const screen = routeScreenMapping[pathname]
    if (screen && !_.isEmpty(userDetails)) {
      const path = FirebaseService.getDefaultPath()
      FirebaseService.patch(
        { [FIREBASE_STATE_KEYS.ACTIVE_SCREEN]: screen },
        `${path}${userDetails.uuid}`
      )
    }
  }, [pathname, userDetails])
  return props.children
})
